/**
 * Template: Get to know us
 * -----------------------------------------------------------------------------
 * Scripts to execute on the get to know us page.
 *
 */
import { load } from '@shopify/theme-sections';
import '~/sections/homepage-usps--carousel';
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});